<h1 class="container-heading">Label</h1>

<mat-card>
    <mat-card-content>
        <form [formGroup]="formGroup" style="max-width: 800px;">
            <div class="group flex">
                <mat-form-field class="full">
                    <mat-label>Label name</mat-label>
                    <input type="text" matInput formControlName="name">
                </mat-form-field>

                <mat-form-field class="half">
                    <mat-label>Label type</mat-label>
                    <mat-select formControlName="type">
                        <mat-option value="text">
                            Free text
                        </mat-option>
                        <mat-option value="inventory">
                            Inventory sticker
                        </mat-option>
                        <mat-option value="box">
                            Box sticker
                        </mat-option>
                        <mat-option value="pallet">
                            Pallet sticker
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="half">
                    <mat-label>Sorting order</mat-label>
                    <input type="number" matInput formControlName="sorting_order" min="1">
                </mat-form-field>

                <div class="full margin-bottom-20">
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Sticker size:
                                </mat-panel-title>
                                <mat-panel-description>
                                    {{ showSizeString(formGroup.value.size) }}
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <div>
                                <mat-radio-group [formControl]="formGroup.get('size').get('id')">
                                    <div *ngFor="let size of labelSizes">
                                        <mat-radio-button [value]="size.id">
                                            {{ showSizeString(size) }}
                                        </mat-radio-button>
                                    </div>
                                    <div>
                                        <mat-radio-button [value]="0">
                                            Other (keep name to update)
                                        </mat-radio-button>
                                    </div>
                                </mat-radio-group>

                                <div class="group flex" formGroupName="size" *ngIf="formGroup.value.size.id === 0">
                                    <mat-form-field class="full">
                                        <mat-label>Size name</mat-label>
                                        <input type="text" matInput formControlName="name">
                                    </mat-form-field>

                                    <mat-form-field class="half">
                                        <mat-label>Width, mm</mat-label>
                                        <input type="number" matInput formControlName="width" max="500" min="10"
                                               step="1">
                                    </mat-form-field>

                                    <mat-form-field class="half">
                                        <mat-label>Height, mm (set to 0 for auto-height)</mat-label>
                                        <input type="number" matInput formControlName="height" min="0" step="1">
                                    </mat-form-field>
                                </div>

                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>

                <div class="full">
                    <h3>Free text:</h3>
                    <common-form-editor [value]="editorInitialValue"
                                        (valueChange)="formGroup.get('body').setValue($event)"></common-form-editor>
                </div>
            </div>
        </form>

        <div class="group flex sticker-layout" style="width: 800px; margin: 0 auto 20px; position: relative;">
            <div class="quarter">
                <div style="position: sticky; top: 80px;">
                    <div class="full">
                        <h2>Available elements:</h2>
                    </div>
                    <div class="full available-elements margin-right-10"
                         style="overflow: auto;max-height: 420px;"
                         dragula="ITEMS" [(dragulaModel)]="stickerElements">
                        <div class="drag-element" *ngFor="let element of stickerElements">
                            {{ element.name }}
                        </div>
                    </div>
                </div>

            </div>
            <div class="quarter3">
                <div class="full">
                    <h2>Sticker layout:</h2>
                </div>
                <div class="full sticker-tiles">
                    <div class="tiles-container" dragula="TILES" [(dragulaModel)]="tiles">
                        <div *ngFor="let tile of tiles; let i = index"
                             [style.width]="tile.size"
                             [style.background]="tile.color"
                             class="tile">

                            <div class="tile-controls">
                                <div class="tile-control" title="Drag to reorder">
                                    <mat-icon class="tile-drag-handle">drag_pan</mat-icon>
                                </div>
                                <div class="tile-control edit-tile" (click)="editTile(tile)" title="Edit">
                                    <mat-icon>edit</mat-icon>
                                </div>
                                <div class="tile-control remove-tile" (click)="removeTile(i)" title="Remove">
                                    <mat-icon>delete</mat-icon>
                                </div>
                            </div>

                            <div class="tile-content" dragula="ITEMS" [(dragulaModel)]="tile.content"
                                 [style.justify-content]="setVerticalAlign(tile.align_v)"
                                 [style.align-items]="setHorizontalAlign(tile.align_h)">
                                <div class="drag-element" *ngFor="let element of tile.content">
                                    {{ element.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="padding-10">
                        <button mat-raised-button color="accent" (click)="addTile()">
                            Add block
                        </button>
                    </div>

                </div>
            </div>
        </div>

        <mat-divider class="margin-bottom-20"></mat-divider>

        <h2 class="margin-bottom-20" style="max-width: 600px; margin: 0 auto;">Preview:</h2>

        <div class="form margin-bottom-20">
            <mat-checkbox #showOutline checked>Show blocks outline</mat-checkbox>
        </div>

        <div class="label-preview" #sticker [class.outline]="showOutline.checked">
            <section-custom-label-renderer
                    [width]="formGroup.value.size.width"
                    [height]="formGroup.value.size.height"
                    [layout]="stickerLayout"
                    [data]="stickerData"
            ></section-custom-label-renderer>
        </div>

        <div [formGroup]="formGroup" *userAllowed="['templates_custom_labels']">
            <mat-checkbox formControlName="is_template">
                Save as template
            </mat-checkbox>
            <small>
                (this cannot be changed in the future)
            </small>
        </div>

        <div class="actions padding-top-20">
            <button mat-raised-button color="accent" (click)="print()">
                <mat-icon>print</mat-icon>
                Print preview
            </button>

            <ng-container *ngIf="owned">
                <button mat-raised-button color="primary" (click)="saveLabel()"
                        *userAllowed="['add_custom_labels','edit_custom_labels']"
                        [disabled]="!formGroup.valid">
                    Save
                </button>

                <ng-container *userAllowed="['delete_custom_labels']">
                    <button *ngIf="state.params.id" mat-raised-button color="warn" (click)="deleteLabel()">
                        Delete
                    </button>
                </ng-container>

            </ng-container>
            <button mat-raised-button (click)="goToList()">
                Close
            </button>
        </div>

    </mat-card-content>
</mat-card>
<common-confirm></common-confirm>
<common-alert></common-alert>
